import mutations from './laborReport.mutations'
import actions from './laborReport.actions'
import getters from './laborReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
